import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
function useOnScreen(ref, t0) {
  const $ = _c(4);
  const rootMargin = t0 === undefined ? "0px" : t0;
  const [isIntersecting, setIntersecting] = useState(false);
  let t1;
  if ($[0] !== ref || $[1] !== rootMargin) {
    t1 = () => {
      const observer = new IntersectionObserver(t2 => {
        const [entry] = t2;
        setIntersecting(entry.isIntersecting);
      }, {
        rootMargin
      });
      if (ref.current) {
        observer.observe(ref.current);
      }
      return () => {
        if (ref.current) {
          observer.unobserve(ref.current);
        }
      };
    };
    $[0] = ref;
    $[1] = rootMargin;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [];
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  useEffect(t1, t2);
  return isIntersecting;
}
export default useOnScreen;